import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import style from "../styles/checkout-pages.module.scss";
import { PaymentContext } from "../context/payment-success-context";
import { BottomSpacer } from "../components/spacer";
import { trackEvent } from "../analytics/events";
import { formatCurrency } from "../utils/funcs/pricing";

const getStoredItem = () => {
  try {
    const stored = localStorage.getItem("item");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

function SuccessIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export default function CheckoutSuccess() {
  const { setPaymentSuccess, bookingItem } = useContext(PaymentContext);
  const item = bookingItem || getStoredItem();

 const hasTracked = useRef(false);

 useEffect(() => {
  window.fbq?.("track", "PageView");
  window.fbq?.("track", "Schedule");
}, []);

useEffect(() => {
  if (!item || hasTracked.current) return;

  hasTracked.current = true;

  trackEvent("payment_success", {
    booking_id: item.bookingID,
    product_name: item.productName,
    service: item.productName,
    service_name: item.productName,
    value: Number(item.finalPrice || 0),
  });
}, [item]);

  useEffect(() => {
   
    setPaymentSuccess(true);
  }, [setPaymentSuccess]);

  const navigate = useNavigate();

  return (
    <div className={style.page}>
      <div className={style.card}>
        <div className={style.iconWrapSuccess}>
          <SuccessIcon />
        </div>

        <h1 className={style.heading}>Payment Confirmed</h1>
        <p className={style.subheading}>
          Thanks for your booking — your payment went through successfully.
        </p>

        {item ? (
          <>
            <div className={style.divider} />
            <div className={style.detailsGrid}>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Service</span>
                <span className={style.detailValue}>{item.productName}</span>
              </div>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Booking ID</span>
                <span className={style.detailValue}>{item.bookingID}</span>
              </div>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Name</span>
                <span className={style.detailValue}>{item.customerName}</span>
              </div>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Date</span>
                <span className={style.detailValue}>{item.emailDate}</span>
              </div>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Time</span>
                <span className={style.detailValue}>{item.emailStartTime} – {item.emailEndTime}</span>
              </div>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Address</span>
                <span className={style.detailValue}>{item.address?.line1}, {item.address?.postcode}</span>
              </div>
              <div className={style.detailRow}>
                <span className={style.detailLabel}>Amount paid</span>
                <span className={style.detailValue}><span className={style.badge}>{formatCurrency(Number(item.finalPrice || 0))}</span></span>
              </div>
            </div>

            <p className={style.emailNote}>
              A confirmation email is on its way to you. If you don't see it, check your junk folder.
            </p>
          </>
        ) : (
          <p className={style.emailNote}>
            We couldn't load your booking details. Please contact us with your payment reference and we'll confirm everything manually.
          </p>
        )}

        <div className={style.actions}>
          <button className={style.primaryBtn} onClick={() => navigate("/book-now")}>
            Book another service
          </button>
          <a href="/contact-us" className={style.secondaryLink}>Need help? Contact us</a>
        </div>
      </div>
      <BottomSpacer />
    </div>
  );
}

